import { Link } from "react-router-dom";
import { MessageCircle, MapPin, Store, Users, ArrowRight } from "lucide-react";
import { Seo } from "../components/Seo";
import { site, categories, waLink, waGeneralMessage } from "../data/store";

export default function Tentang() {
  return (
    <>
      <Seo
        title="Tentang Kami | Nuansa Jaya Abadi Bajawa"
        description="Kenali Nuansa Jaya Abadi (NJA), toko bangunan di Jl. Basuki Rahmat, Bajawa, Kabupaten Ngada, yang melayani kebutuhan bangunan dan renovasi."
        path="/tentang"
      />

      <section className="mx-auto max-w-4xl px-4 py-10 sm:px-6 lg:py-16">
        <h1 className="text-3xl font-extrabold text-navy sm:text-4xl">
          Tentang {site.name}
        </h1>
        <p className="mt-6 text-base leading-relaxed text-slate-600 md:text-lg">
          {site.name} ({site.shortName}) adalah toko bangunan yang berlokasi
          di {site.address}, {site.region}. Kami fokus membantu masyarakat
          Bajawa dan sekitarnya memenuhi kebutuhan bahan bangunan — baik untuk
          pembangunan baru maupun renovasi rumah.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-3">
          {[
            {
              icon: Store,
              title: "Toko bahan bangunan",
              text: "Menyediakan berbagai jenis bahan bangunan, dari material dasar hingga perlengkapan finishing.",
            },
            {
              icon: Users,
              title: "Untuk semua pelanggan",
              text: "Melayani pemilik rumah, tukang, dan kontraktor dengan kebutuhan skala kecil maupun besar.",
            },
            {
              icon: MessageCircle,
              title: "Mudah dihubungi",
              text: "Cukup kirim daftar kebutuhan melalui WhatsApp untuk menanyakan harga dan ketersediaan barang.",
            },
          ].map((item) => (
            <div key={item.title} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
              <item.icon className="h-7 w-7 text-brand" aria-hidden="true" />
              <h2 className="mt-4 text-lg font-semibold text-navy">{item.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{item.text}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <h2 className="flex items-center gap-2 text-lg font-semibold text-navy">
            <MapPin className="h-5 w-5 text-brand" aria-hidden="true" />
            Lokasi kami
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            {site.address}, {site.region}. Silakan kunjungi toko kami untuk
            melihat langsung barang yang tersedia, atau hubungi kami terlebih
            dahulu melalui WhatsApp.
          </p>
        </div>

        <div className="mt-10">
          <h2 className="text-lg font-semibold text-navy">Kategori yang kami sediakan</h2>
          <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/produk/${c.slug}`}
                  data-testid={`about-category-${c.slug}`}
                  className="group flex items-center justify-between rounded-2xl border border-slate-200 bg-white p-4 text-sm font-medium text-navy shadow-sm transition-shadow duration-300 hover:shadow-md"
                >
                  {c.name}
                  <ArrowRight className="h-4 w-4 text-brand transition-transform duration-300 group-hover:translate-x-0.5" aria-hidden="true" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-10 rounded-2xl bg-navy p-6 text-white shadow-lg sm:p-8">
          <h2 className="text-lg font-semibold sm:text-xl">Ada kebutuhan bangunan atau renovasi?</h2>
          <p className="mt-2 text-sm leading-relaxed text-white/80">
            Kirimkan daftar kebutuhan Anda dan kami bantu cek harga serta ketersediaannya.
          </p>
          <a
            href={waLink(waGeneralMessage)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="about-whatsapp-cta"
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-wa px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:bg-wa-dark"
          >
            <MessageCircle className="h-5 w-5" aria-hidden="true" />
            Tanya via WhatsApp
          </a>
        </div>
      </section>
    </>
  );
}
